import { LiveData, Service } from '@toeverything/infra';

import { GlobalStateService } from '../../storage';
import { QuickSearchService } from './quick-search';

export type PreferredQuickSearchView = 'normal' | 'advanced';

export const PREFERRED_QUICK_SEARCH_VIEW_KEY = 'quickSearch:preferredView';

export class AdvancedSearchService extends Service {
  constructor(
    private readonly globalStateService: GlobalStateService,
    _quickSearchService: QuickSearchService
  ) {
    super();
  }

  readonly open$ = new LiveData(false);
  readonly query$ = new LiveData('');

  open(initialQuery = '') {
    // Presentation changes retain the one QuickSearch session owner.
    this.query$.next(initialQuery);
    this.open$.next(true);
  }

  close() {
    this.open$.next(false);
  }

  prefersAdvanced() {
    return (
      this.globalStateService.globalState.get<PreferredQuickSearchView>(
        PREFERRED_QUICK_SEARCH_VIEW_KEY
      ) === 'advanced'
    );
  }

  setPreferredView(view: PreferredQuickSearchView) {
    this.globalStateService.globalState.set<PreferredQuickSearchView>(
      PREFERRED_QUICK_SEARCH_VIEW_KEY,
      view
    );
  }
}
